// extracted by mini-css-extract-plugin
export default {"overlayContainer":"overlayContainer---W3T5s"};